
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton, AppAvatarBreadcrumb } from '@/components';
import { useAvatarImageList } from '@/modules/avatar/item/image/model/list';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.ITEM.IMAGE.INDEX,
    components: { AppTable, AppCard, AppButton, AppAvatarBreadcrumb },
    setup() {
        const { list, total, query, fetchList, model, actions } = useAvatarImageList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                { type: TableColumnType.Html, label: 'Color', htmlHandler: (row: any) => row.color },
                { type: TableColumnType.Text, label: 'Layer', key: 'layer' },
                { type: TableColumnType.Boolean, label: 'Is default', key: 'isDefault' },
                { type: TableColumnType.Image, label: 'Image', imageKey: 'image', statusKey: 'imageStatus' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: {
                            name: ROUTE_NAME_AVATAR.ITEM.IMAGE.EDIT,
                            params: { itemId: model.itemId, imageId: row.id }
                        }
                    }),
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(model.itemId, row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, query, fetchList, model, actions, ROUTE_NAME_AVATAR };
    }
});
